import React from "react";
import ContactSection from "../../components/client-side/contactus/ContactSection";
import ContactCTA from "../../components/client-side/homepage/ContactSection";

const ContactPage = () => {
  return (
    <main className="bg-background text-black dark:text-textDark">
      <ContactSection email="play@mr-reel.com" />
      <ContactCTA />
    </main>
  );
};

export default ContactPage;
